import React, { FC } from 'react';
import { default as MuiToggleButton } from '@material-ui/lab/ToggleButton';
import { default as MuiToggleButtonGroup } from '@material-ui/lab/ToggleButtonGroup';
import { withStyles } from '@material-ui/core/styles';
import { ToggleButtonGroupProps } from './types';
import styles from './style';

const StyledMuiToggleButton = withStyles(styles)(MuiToggleButton);

const ToggleButtonGroup: FC<ToggleButtonGroupProps> = (props) => {
  const {
    value,
    exclusive = true,
    onChange,
    size = 'medium',
    toggleButtons,
    ariaLabel,
  } = props;
  return (
    <MuiToggleButtonGroup
      value={value}
      exclusive={exclusive}
      onChange={onChange}
      size={size}
      aria-label={ariaLabel}
    >
      {
        toggleButtons.map(toggleButton => {
          const { value, disabled, children } = toggleButton;
          return <StyledMuiToggleButton
            key={value}
            value={value}
            disabled={disabled}
            disableFocusRipple={true}
            disableRipple={true}
            aria-label={value}
          >
            {children}
          </StyledMuiToggleButton>
        })
      }
    </MuiToggleButtonGroup>
  );
};

export default ToggleButtonGroup;
